import { Chip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ROOM_TYPE_EDIT, ROOM_TYPE_VIEW_TABS } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allCategoriesSelector,
  allRoomsSelector,
  allRoomTypesSelector,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import './Room-Type-View.scss';
import { getCurrencyNameFromCode } from '../../../../../utils/commonUtils';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const RoomTypeView = (props) => {
  const { roomType, onViewToggle, hotelId, toggleDrawer, permissions } = props;
  const [selectedRoomType, setSelectedRoomType] = useState();
  const [tabValue, setTabValue] = useState(0);

  const originalCateogires = useSelector(allCategoriesSelector);
  const originalRoomTypes = useSelector(allRoomTypesSelector);
  const originalRooms = useSelector(allRoomsSelector);
  const currency = useSelector(selectedHotelCurrencySelector);

  useEffect(() => {
    if (hotelId && roomType.id) {
      const roomTypeObj = {
        ...originalRoomTypes.find((tempRoomType) => tempRoomType.id === roomType.id),
      };
      roomTypeObj['category'] = originalCateogires.find((c) => c.id === roomTypeObj.categoryId);
      roomTypeObj['rooms'] = originalRooms.filter((room) => room.roomTypeId === roomTypeObj.id);

      setSelectedRoomType(roomTypeObj);
    }
  }, [hotelId, originalRoomTypes]);

  const getRooms = (rooms) => {
    let roomList = rooms.map((room) => {
      return room.number;
    });

    return roomList.sort().join(', ');
  };

  const onClickEdit = (event) => {
    toggleDrawer(ROOM_TYPE_EDIT, true, selectedRoomType);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Room Type Display Name</div>
                <div className='details-value preview-breaks'>{selectedRoomType?.name}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Room Type code</div>
                <div className='details-value'>{selectedRoomType?.code}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Display Description</div>
                <div className='details-value preview-breaks'>
                  {selectedRoomType?.displayDescription}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Category</div>
                <div className='details-value'>{selectedRoomType?.category?.name}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Category Code</div>
                <div className='details-value'>{selectedRoomType?.category?.code}</div>
              </div>
            </div>

            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>No.of Rooms</div>
                <div className='details-value'>{selectedRoomType?.rooms?.length}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Room Numbers</div>
                <div className='details-value'>
                  {selectedRoomType?.rooms?.length ? getRooms(selectedRoomType?.rooms) : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Rate per night</div>
                <div className='details-value'>
                  {selectedRoomType?.ratePerNight
                    ? `${getCurrencyNameFromCode(currency)} ${selectedRoomType?.ratePerNight}`
                    : '---'}
                </div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Status</div>
                <div className='details-value'>
                  <div
                    className={`${
                      selectedRoomType?.isActive ? 'pill-active' : 'pill-inactive'
                    } col-md-2 pill-text pill mt-3`}
                  >
                    {selectedRoomType?.isActive ? 'Active' : 'Inactive'}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Maximum Occupants</div>
                <div className='details-value'>{selectedRoomType?.maxOccupants || '---'}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Maximum Adults</div>
                <div className='details-value'>{selectedRoomType?.maxAdults || '---'}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Maximum Children</div>
                <div className='details-value'>{selectedRoomType?.maxChildren || '---'}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Maximum Infants</div>
                <div className='details-value'>{selectedRoomType?.maxInfants || '---'}</div>
              </div>
            </div>
          </>
        )}
        {tabValue === 1 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-8'>
                <div className='details-label'>Highlight Features</div>
                <div className='details-value mt-3'>
                  {selectedRoomType?.features?.length
                    ? selectedRoomType?.features?.map((feature, i) => (
                        <Chip key={i} label={feature} className='me-3 mb-2' variant='outlined' />
                      ))
                    : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-8'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>
                  {selectedRoomType?.description ? selectedRoomType?.description : '---'}
                </div>
              </div>
            </div>
          </>
        )}
        {tabValue === 2 && (
          <div className='row pt-4 px-3'>
            <MediaViewer
              images={selectedRoomType.images}
              videos={(() => {
                const { Video: videoMediaContent } = decodeMediaKeyValue(
                  selectedRoomType?.mediaContent,
                );
                return videoMediaContent || selectedRoomType.videos || {};
              })()}
              gifs={(() => {
                const { GIF: gifMediaContent } = decodeMediaKeyValue(
                  selectedRoomType?.mediaContent,
                );
                return gifMediaContent || selectedRoomType.gifs || {};
              })()}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {selectedRoomType && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={ROOM_TYPE_VIEW_TABS}
          onViewToggle={onViewToggle}
          title={selectedRoomType?.name}
          createdUserId={selectedRoomType?.createdBy}
          isEditable={
            permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default RoomTypeView;
